import ApiService from "../../ApiService";
import { ISites, ISiteDetails } from "./interfaces";
import { AxiosResponse } from "axios";

export const List = async (
  userId: string,
  pagination = { page: 1, limit: 10, query: "" }
): Promise<ISites> => {
  try {
    ApiService.setHeader();

    const response = await ApiService.query(
      `users/${userId}/accounts/list?page=${pagination.page}&limit=${pagination.limit}&query=${pagination.query}`,
      {}
    );

    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const Details = async (accountId: any): Promise<ISiteDetails> => {
  try {
    ApiService.setHeader();

    const response = await ApiService.query(`account/${accountId}/details`, {});

    return response.data[0];
  } catch (error) {
    return Promise.reject(error);
  }
};

export const Consents = async (
  siteId: string,
  query = {},
  pagination = { page: 1, limit: 6 }
): Promise<any> => {
  try {
    ApiService.setHeader();

    const response = await ApiService.post(
      `visitorConsents/all/${siteId}?page=${pagination.page}&limit=${pagination.limit}`,
      query
    );

    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
